/**
 * Get the video ID from the given Youtube url
 *
 * @param {string} url
 * @returns {string}
 */
const getYoutubeId = url => {
  let videoId;

  if (url && url.match(/youtube.com/)) {
    videoId = url.split('/watch?v=')[1];
  }

  if (url && url.match(/youtu.be/)) {
    videoId = url.split('youtu.be/')[1];
  }

  return videoId;
};

export default getYoutubeId;
